// SVG zone primitives for the Asbestos FloorCanvas: shape rendering + resize handles.
import { STATUS_FILL, STATUS_STROKE } from "./constants";

export function ResizeHandles({ z, invScale, onGrab }) {
    const r = 5.5 * invScale;
    const sw = 1.4 * invScale;
    const handle = (key, x, y, kind, index) => (
        <rect key={key} data-testid={`asbestos-handle-${kind}-${index}`}
            x={x - r} y={y - r} width={r * 2} height={r * 2} rx={1.2 * invScale}
            fill="#fff" stroke="#1F6FE5" strokeWidth={sw}
            style={{ cursor: "pointer" }}
            onPointerDown={(e) => { e.stopPropagation(); onGrab(kind, index); }} />
    );
    if (z.shape === "rectangle") {
        const [x1, y1, x2, y2] = z.coords;
        return <g>{[[x1, y1], [x2, y1], [x2, y2], [x1, y2]].map(([x, y], i) => handle(i, x, y, "corner", i))}</g>;
    }
    if (z.shape === "circle") {
        const [cx, cy, rad] = z.coords;
        return <g>{handle("r", cx + rad, cy, "radius", 0)}</g>;
    }
    if (z.shape === "polygon") {
        const hs = [];
        for (let i = 0; i < z.coords.length; i += 2) hs.push(handle(i, z.coords[i], z.coords[i + 1], "vertex", i / 2));
        return <g>{hs}</g>;
    }
    return null;
}

export function ZoneShape({ z, testId, selected, hovered, invScale, cursor = "pointer", onClick, onPointerDownShape, onEnter, onLeave }) {
    const fill = STATUS_FILL[z.status] || STATUS_FILL.unknown;
    const stroke = STATUS_STROKE[z.status] || STATUS_STROKE.unknown;
    const sw = (selected ? 3 : hovered ? 2.4 : 1.6) * invScale;
    const common = { "data-testid": testId, fill, stroke, strokeWidth: sw, onClick, onPointerDown: onPointerDownShape, onMouseEnter: onEnter, onMouseLeave: onLeave, style: { cursor }, strokeDasharray: selected ? `${5 * invScale} ${3 * invScale}` : undefined };
    if (z.shape === "rectangle") {
        const [x1, y1, x2, y2] = z.coords;
        return <rect x={Math.min(x1, x2)} y={Math.min(y1, y2)} width={Math.abs(x2 - x1)} height={Math.abs(y2 - y1)} {...common} />;
    }
    if (z.shape === "circle") {
        const [cx, cy, r] = z.coords;
        return <circle cx={cx} cy={cy} r={r} {...common} />;
    }
    if (z.shape === "polygon") {
        const pts = [];
        for (let i = 0; i < z.coords.length; i += 2) pts.push(`${z.coords[i]},${z.coords[i + 1]}`);
        return <polygon points={pts.join(" ")} {...common} />;
    }
    return null;
}
